<dxc-togglegroup 
  [margin]="margin" 
  label="{{ label | translate }}"
  [multiple]="multiple"
  [disabled]="disabled"
  [tabIndex]="tabIndex"
  [value]="value"
  (onChange)="onChangeValue($event)">
  <ng-container *ngFor="let item of listToggle">
    <dxc-toggle 
      [class.active]="activeClass == true && value == item.value"
      label="{{item.label | translate}}" 
      value="{{item.value}}">
      <dxc-toggle-icon *ngIf="item.icon">
        <img src="{{item.icon}}" alt="">
      </dxc-toggle-icon>
    </dxc-toggle>
  </ng-container>
</dxc-togglegroup>